// extracted by mini-css-extract-plugin
module.exports = {"containerStyling":"SendgridAddContact-module--containerStyling--2tJ-T","errorText":"SendgridAddContact-module--errorText--aCd04"};